import { render, staticRenderFns } from "./CaseListing-Closed.vue?vue&type=template&id=2cc0e359&"
import script from "./CaseListing-Closed.vue?vue&type=script&lang=js&"
export * from "./CaseListing-Closed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports